import { render, staticRenderFns } from "./PartsCustomerControl.vue?vue&type=template&id=eb8025c8&scoped=true"
import script from "./PartsCustomerControl.vue?vue&type=script&lang=js"
export * from "./PartsCustomerControl.vue?vue&type=script&lang=js"
import "./PartsCustomerControl.vue?vue&type=style&index=0&id=eb8025c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8025c8",
  null
  
)

export default component.exports